import { IDroneAreasState, actionTypes } from 'src/ducks/drone-areas.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getDroneAreasStatus = (
  state: IDroneAreasState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
